class LocationTypeService {

  constructor(ApiService, LocationTypeSchema) {
    this.ApiService = ApiService;
    this.LocationTypeSchema = LocationTypeSchema;
  }

  getAll() {
    var self = this;
    return self.ApiService.get('/api/locationtypes')
        .then( (response) => { return response.data });
  }

}
LocationTypeService.$inject = ['ApiService', 'LocationTypeSchema'];
export default LocationTypeService;
